import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const ReactiveDataWidgetV2: WidgetRegistryEntry = {
  name: "ReactiveDataV2",
  configuration: () => import("./configuration").then((m) => m.ReactiveDataWidgetV2Configuration),
  component: () => import("./reactive-data-widget-v2.component").then((m) => m.ReactiveDataWidgetV2Component)
};
